import type { SchemaOptions } from '@crmsy/shared';
import { GROUP_PROPERTY, type GroupNode } from '../lib/grouping.js';
import { optionColor } from './Tag.jsx';

/** A group's heading (D-38): chevron, value (as its Notion tag where it has a colour), count. Click collapses. */
export function GroupHeader<T>({ node, collapsed, schema, onToggle }: { node: GroupNode<T>; collapsed: boolean; schema: SchemaOptions; onToggle: () => void }) {
  const property = GROUP_PROPERTY[node.key];
  const color = property && node.value ? optionColor(schema, property, node.value) : undefined;
  const tone = node.key === 'due' && node.value === 'overdue' ? 'text-danger' : node.key === 'due' && node.value === 'today' ? 'text-warn-ink' : 'text-muted';
  const size = node.level === 0 ? 'text-xs font-semibold uppercase tracking-wide' : 'text-xs font-medium';
  return (
    <button
      type="button"
      className={`flex w-full items-center gap-2 text-left ${size} ${tone} hover:text-ink`}
      style={{ paddingLeft: node.level * 16 }}
      onClick={onToggle}
      aria-expanded={!collapsed}
      data-group-header={node.path}
    >
      <span className="w-3 text-center" aria-hidden>
        {collapsed ? '▸' : '▾'}
      </span>
      {color ? (
        <span className="tag normal-case tracking-normal" data-color={color}>
          {node.label}
        </span>
      ) : (
        <span>{node.label}</span>
      )}
      <span className="font-normal">· {node.count}</span>
    </button>
  );
}
